import { fetcher } from "helpers/fetcher";

import { TGetBUGlobalReq, TGetBUGlobalRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUGlobal = async (params?: TGetBUGlobalReq) => {
  return await fetcher<TGetBUGlobalRes, TGetBUGlobalReq>(
    ENDPOINT.BU.GET_BU_GLOBAL,
    {
      data: params,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_GLOBAL.version,
      },
    }
  );
};

export const queryGetBUGlobal = async (params?: TGetBUGlobalReq) => {
  return (await getBUGlobal(params)).data;
};

queryGetBUGlobal._key = (params?: TGetBUGlobalReq) => [
  ENDPOINT.BU.GET_BU_GLOBAL.url,
  params,
];
